import _regeneratorRuntime from "/data/maven/.jenkins/workspace/web/web/node_modules/@babel/runtime/regenerator";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//  limit_queryPage, , , limit_import, saveLimit, deleteLimit,
import { getSalesInfo, deleteSales, saveSales, prohibitSales, lookSales, importSales, findAllCompany, getExcelPath, download } from '@/api/baseDataManage';
import { getCompanyList } from '@/api/baseDate';
export default {
  name: 'bcSales',
  data: function data() {
    var testEmail = /*#__PURE__*/function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(rule, item, callback) {
        var re;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                re = /^([a-zA-Z0-9_\.\-])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/g;

                if (!item) {
                  _context.next = 4;
                  break;
                }

                if (re.test(item)) {
                  _context.next = 4;
                  break;
                }

                return _context.abrupt("return", callback(new Error('电子邮箱格式不正确')));

              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function testEmail(_x, _x2, _x3) {
        return _ref.apply(this, arguments);
      };
    }();

    var emailValidator = function emailValidator(rule, value, callback) {
      if (value) {
        var valueList = value.split(",");
        valueList.map(function (item) {
          testEmail(rule, item, callback);
        });
        callback();
      } else {
        callback();
      }
    };

    return {
      activeAffiliationList1: [],
      activeAffiliationList2: [],
      affiliationComList: [],
      affiliationCom: '',
      //归属机构显示1
      fileList: [],
      company: '',
      //保险公司
      companyList: [],
      //获取保险公司列表并匹配
      // 查询条件
      form: {
        affiliationComCode: '',
        //归属机构代码 (字符串)
        affiliationComName: '',
        //归属机构名称(字符串)
        insuranceCompanyCode: '',
        //保险公司代码(字符串) 必传!
        insuranceCompanyName: '',
        //保险公司名称(字符串)
        pageNo: 1,
        //int类型 –第几页 必传!
        pageSize: 10,
        //int 类型 –每页数量 必传!
        salesCode: '',
        //业务员代码 (字符串)
        salesName: '',
        //业务员名称(字符串)
        validStatus: '',
        //是否有效
        validStatusName: ''
      },
      total: 0,
      //数据条数
      // 列表数据
      tableData: [],
      loading: false,
      screenLoading: null,
      newumarBtn: false,
      new_edit: false,
      editData: {},
      markForm: {
        affiliationCom: '',
        salesCode: '',
        //业务员代码
        salesName: '',
        //业务员名称
        affiliationComCode: '',
        //归属机构代码 (字符串)
        affiliationComName: '',
        //归属机构名称
        email: '',
        //邮箱
        type: '',
        salesId: ''
      },
      markForm_new: {
        affiliationCom: '',
        salesCode: '',
        //业务员代码
        salesName: '',
        //业务员名称
        affiliationComCode: '',
        //归属机构代码 (字符串)
        affiliationComName: '',
        //归属机构名称
        email: '',
        //邮箱
        type: '',
        salesId: ''
      },
      limitrule: {
        salesCode: [{
          required: true,
          message: '请输入业务员代码',
          trigger: 'blur'
        }],
        salesName: [{
          required: true,
          message: '请输入业务员名称',
          trigger: 'blur'
        }],
        affiliationComCode: [{
          required: true,
          message: '请选择归属机构',
          trigger: 'change'
        }],
        email: [{
          required: true,
          message: '请输入电子邮箱',
          trigger: 'blur'
        }, {
          validator: emailValidator,
          trigger: 'blur'
        } //{ pattern: /^([a-zA-Z0-9_\.\-])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/, message: '电子邮箱格式不正确' }
        ]
      }
    };
  },
  mounted: function mounted() {
    var _this = this;

    getCompanyList().then(function (res) {
      _this.companyList = Object.assign([], res); // this.company = this.form.insuranceCompanyCode = this.$store.state.user.userinfo.insuranceCompanyList[0].insuranceCompanyCode

      _this.company = _this.form.insuranceCompanyCode = JSON.parse(sessionStorage.getItem('newinsurancecompanyCode'));

      _this.getData();
    });
  },
  methods: {
    // 归属机构列表变化
    changeaffiliationCom: function changeaffiliationCom(e) {
      console.log(e, 'eee');
      this.markForm_new.affiliationComCode = '';
      this.markForm_new.affiliationComName = '';
      this.markForm.affiliationComCode = '';
      this.markForm.affiliationComName = '';
      var activeAffiliationList = [];
      var that = this;
      e.forEach(function (val) {
        activeAffiliationList.push({
          affiliationCode: val.split('-')[0],
          affiliationName: val.split('-')[1]
        });

        if (that.markForm_new.affiliationComCode != '') {
          that.markForm_new.affiliationComCode += '|';
          that.markForm_new.affiliationComName += '|';
          that.markForm.affiliationComCode += '|';
          that.markForm.affiliationComName += '|';
        }

        that.markForm_new.affiliationComCode += val.split('-')[0];
        that.markForm_new.affiliationComName += val.split('-')[1];
        that.markForm.affiliationComCode += val.split('-')[0];
        that.markForm.affiliationComName += val.split('-')[1];
      });
      console.log(activeAffiliationList);
      console.log(this.markForm_new.affiliationComCode);
    },
    // 获取归属机构list
    findAllList: function findAllList() {
      var _this2 = this;

      findAllCompany().then(function (res) {
        console.log(res);
        _this2.affiliationComList = Object.assign([], res);
      });
    },
    // 新增
    newbut: function newbut() {
      this.newumarBtn = true;
      this.findAllList();
    },
    // 是否有效下拉框change
    changeStatus: function changeStatus(e) {
      console.log(e);
      this.form.validStatus = e.toString();
    },
    // 业务员查询
    getData: function getData() {
      var _this3 = this;

      this.loading = true;
      getSalesInfo(_objectSpread({}, this.form)).then(function (res) {
        _this3.loading = false;
        console.log(res, 'res');
        _this3.total = res.totalCount;
        _this3.tableData = Object.assign([], res.content);
      });
    },
    //   查询
    submitForm: function submitForm(formName) {
      console.log(formName);
      this.form.pageNo = 1;
      this.getData(formName);
    },
    //   重置查询条件
    resetForm: function resetForm(formName) {
      console.log(formName);
      this.form.affiliationComCode = '', //归属机构代码 (字符串)
      this.form.affiliationComName = '', //归属机构名称(字符串)
      this.form.salesCode = '', //业务员代码 (字符串)
      this.form.salesName = '', //业务员名称(字符串)
      this.form.validStatus = '', //是否有效
      this.form.validStatusName = '';
      this.getData();
    },
    // 分页方法
    handleSizeChange: function handleSizeChange(val) {
      this.form.pageSize = val;
      this.getData();
    },
    handleCurrentChange: function handleCurrentChange(val) {
      this.form.pageNo = val;
      this.getData();
    },
    // // 删除
    // dele(data) {
    //   console.log(data)
    //   this.$confirm('此操作将永久删除该文件, 是否继续?', '提示', {
    //     confirmButtonText: '确定',
    //     cancelButtonText: '取消',
    //     type: 'warning'
    //   }).then(() => {
    //     deleteSales({ salesId: data.salesId }).then(res => {
    //       // console.log(res)
    //       if (res.resultCode == '0000') {
    //         this.$message({
    //           type: 'success',
    //           message: '删除成功!'
    //         })
    //         this.getData()
    //       } else {
    //         this.$message({
    //           type: 'warning',
    //           message: res.resultMsg
    //         })
    //       }
    //     })
    //   }).catch(() => {
    //     this.$message({
    //       type: 'info',
    //       message: '已取消删除'
    //     });
    //   });
    // },
    // 禁用
    noRight: function noRight(data, status) {
      var _this4 = this;

      console.log(data);
      var str = '';
      if (status == '0') str = '禁用';else str = '启用';
      this.$confirm("\u6B64\u64CD\u4F5C\u5C06".concat(str, "\u8BE5\u4E1A\u52A1\u5458, \u662F\u5426\u7EE7\u7EED?"), '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        prohibitSales({
          salesId: data.salesId,
          salesStatus: status
        }).then(function (res) {
          if (res.resultCode == "0000") {
            _this4.$message({
              type: 'success',
              message: res.resultMsg
            });

            _this4.getData(1);
          } else {
            _this4.$message({
              type: 'warning',
              message: res.resultMsg
            });
          }
        });
      }).catch(function () {
        _this4.$message({
          type: 'info',
          message: '已取消操作'
        });
      });
    },
    //------------------------------------------------------------
    //编辑/新增保存
    editSave: function editSave(formName, type) {
      var _this5 = this;

      var data = type == 'edit' ? this.markForm : this.markForm_new; // console.log(data);

      if (type == 'edit') {
        this.markForm.type = '1';
      } else {
        this.markForm_new.type = '0';
      }

      console.log(this.markForm);
      console.log(this.markForm_new);
      this.$refs[formName].validate(function (valid) {
        if (valid) {
          _this5.new_edit = _this5.newumarBtn = false;

          _this5.openFullScreen();

          saveSales(data).then(function (res) {
            // console.log(res)
            if (res.resultCode == '0000') {
              _this5.$message({
                message: '保存成功',
                type: 'success'
              });

              for (var key in _this5.markForm_new) {
                _this5.markForm_new[key] = '';
              }

              _this5.activeAffiliationList2 = [];

              _this5.getData();
            } else {
              // this.$message({
              // 	message: res.resultMsg,
              // 	type: 'warning'
              // })
              _this5.$alert(res.resultMsg, '', {
                dangerouslyUseHTMLString: true,
                confirmButtonText: '确定',
                callback: function callback(action) {
                  _this5.newumarBtn = type == 'new' ? true : false;
                  _this5.new_edit = type == 'edit' ? true : false;
                }
              });
            }

            _this5.screenLoading.close();
          });
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    // 编辑
    edit: function edit(data) {
      this.findAllList();
      this.editData = data;
      this.new_edit = true;

      for (var key in this.markForm) {
        this.markForm[key] = data[key];
      } // this.markForm.affiliationCom = data.affiliationComCode + '-' + data.affiliationComName


      var code = data.affiliationComCode.split('|');
      var name = data.affiliationComName.split('|');
      var activeAffiliationList = [];
      code.forEach(function (val, index) {
        activeAffiliationList.push(val + '-' + name[index]);
      });
      this.activeAffiliationList1 = activeAffiliationList;
    },
    // 取消
    selectcancel: function selectcancel(formname, type) {
      var _this6 = this;

      if (type == 'new') {
        this.newumarBtn = false;
      } else {
        this.new_edit = false;
      }

      this.$nextTick(function () {
        _this6.$refs[formname].clearValidate();
      });
    },
    // 获取下载链接
    getExecl: function getExecl() {
      getExcelPath({
        fileDownloadType: 'sales'
      }).then(function (res) {
        if (res.rtnCode == '0000') {
          // 获取下载文件
          download({
            fileSrc: res.fileSrc
          }).then(function (res2) {
            var blob = new Blob([res2], {
              type: "application/vnd.ms-excel"
            }); // 兼容ie

            if (window.navigator && window.navigator.msSaveOrOpenBlob) {
              window.navigator.msSaveOrOpenBlob(blob, "业务员导入模板.xlsx");
            } else {
              var url = window.URL.createObjectURL(blob);
              var link = document.createElement("a"); // 创建a标签

              link.href = url;
              link.download = "业务员导入模板.xlsx"; // 重命名文件

              link.click();
              window.URL.revokeObjectURL(url); // 释放内存
            }
          });
        }
      });
    },
    openFullScreen2: function openFullScreen2() {
      this.screenLoading = this.$loading({
        lock: true,
        text: '导入中',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });
    },
    openFullScreen: function openFullScreen() {
      this.screenLoading = this.$loading({
        lock: true,
        text: '请求中',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });
    },
    // 上传
    importExcel: function importExcel(file) {
      var _this7 = this;

      var extension = file.file.name.substring(file.file.name.lastIndexOf('.') + 1);

      if (extension !== 'xlsx' && extension !== 'xls') {
        this.$message.warning('只能上传后缀是.xlsx或者.xls的文件');
        return;
      }

      var dataFile = new FormData();
      dataFile.append('file', file.file);
      this.openFullScreen2();
      importSales(dataFile).then(function (res) {
        _this7.screenLoading.close();

        if (res.resultCode == '0000') {
          _this7.$message({
            type: 'success',
            message: '导入成功'
          });

          _this7.getData();
        } else {
          _this7.$message({
            type: 'warning',
            message: res.resultMsg
          });
        }
      });
    }
  }
};